import React from 'react';
import { QuotationStatus } from '@/lib/types';

const CONFIG: Record<QuotationStatus, { bg: string; text: string; dot: string; label: string }> = {
  Draft:    { bg: 'bg-slate-100',   text: 'text-slate-600',  dot: 'bg-slate-400',  label: 'Draft' },
  Sent:     { bg: 'bg-blue-50',     text: 'text-blue-700',   dot: 'bg-blue-500',   label: 'Sent' },
  Approved: { bg: 'bg-green-50',    text: 'text-green-700',  dot: 'bg-green-500',  label: 'Approved' },
  Rejected: { bg: 'bg-red-50',      text: 'text-red-700',    dot: 'bg-red-500',    label: 'Rejected' },
};

export default function StatusBadge({ status }: { status: QuotationStatus }) {
  const c = CONFIG[status];
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-600 ${c.bg} ${c.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {c.label}
    </span>
  );
}